import React, { Component } from 'react';
import StockEditProductModal from './StockEditProductModal';
import StockNewInOutModal from './StockNewInOutModal';
import StockProductTransactionModal from './StockProductTransactionModal';
import { Pagination, DropdownButton, MenuItem, Button, Form, FormControl, FormGroup, InputGroup } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import Select from 'react-select';
import FontAwesome from 'react-fontawesome';
import { Checkbox } from 'react-icheck';
import ConfirmPopup from '../../component/element/ConfirmPopup';
import ReportStore from '../../stores/ReportStore';
import StockStore from '../../stores/StockStore';
import ExportExcelButton from './ExportExcelButton';
import StockProductSerialManageModal from './StockProductSerialManageModal';
import RemarkRecordModal from '../../component/element/RemarkRecordModal'
import './Stock.css';
import Parser from 'html-react-parser';
import Moment from 'moment';
import ReportMobileTable from '../report/ReportMobileTable'
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');

class StockSearchPage extends Component {

  constructor(props) {
    super(props)
    const optionsRows = [10,20,50,100,0]
    this.state = {
      loading: true,
      showStockPopup: false,
      showStockNewInOut: false,
      showConfirmDelete: false,
      showProductSerial: false,
      countPartSelect: "",
      btnDisplay: "none",
      rowCheck: [],
      trStyle: [],
      checked: [],
      length: 10,
      optionsRows: optionsRows,
      totalPage: 0,
      activePage: 1,
      data: [],
      localdata:[],
      dataDd: [],
      dataInOut: [],
      defaultOption: "all",
      query: "",
      showStockProductTransactionPopup: false,
      dataSet: {},
      record_type: "",
      defaultQu: [],
      defaultCost: [],
      transaction_record: [],
      productImages: [],
      textCode: [],
      textDes: [],
      remarkTitle:'',
      showRemark:false,
      showItemMore0:false,
      showItem0:false,
      filter:'',
      location:[],
      location_config:[],
      replacement:[],
      spec:{itemnum:'','productcode':'',description:''},
      showAdvanced:false,
      advanced_search:'',
      advanced_q:'',
      advanced_options:[
        {label:this.props.messages['Purchase order no'],value:'purchase_order_no'},
        {label:this.props.messages['Shop purchased'],value:'shop_purchased'},
        {label:this.props.messages['Shop prefer'],value:'shop_prefer'},
        {label:this.props.messages['Product Code'],value:'productcode'},
        {label:this.props.messages['Part Name'],value:'productname'},  
        {label:this.props.messages['Unit'],value:'unit'},
        {label:this.props.messages['Location'],value:'location'},
        {label:this.props.messages['Remark'],value:'remark'},
        {label:this.props.messages['Quantity more than'],value:'quantity_morethan'},
        {label:this.props.messages['Quantity less than'],value:'quantity_lessthan'}
      ]
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    if(this.state.show){
      this.loadData()
    }
  }

  componentWillReceiveProps(newProps){
    
    if(newProps.show && newProps.show!==this.props.show){
      if(this.state.data.length==0)
        this.loadData(1,newProps.catId,'',this.state.filter)
    }
  }

  loadData(page = 1, cat_id = '', query = '', filter = '') {
    this.loadStockList(page,cat_id,query,filter)
    if(this.props.tool!=='part')
      this.loadCategory()
  }

  loadCategory() {
    let that = this

    StockStore.loadCategory(this.props.tool, function (result) {

      that.setState({ dataDd: result.data })
    })
  }

  loadStockList(page = 1, cat_id = '', query = '', filter = '') {
    let that = this
    let {textCode,textDes,showItemMore0,length} = that.state
    textCode.length = length
    textDes.length = length
    this.setState({ loading: true, textCode:textCode, textDes:textDes })
    var start = 0
    if (page === 1) {
      start = 0
      this.setState({ activePage: page })
    } else {
      start = (page * length) - length
    }
    
    ReportStore.loadStockList(this.props.tool, query, cat_id, (showItemMore0?'':start), (showItemMore0?'':length), filter, function (result) {
      let localdata = []
      let totalPage = result.total_count / length
      let dataMap = result.data
      if (showItemMore0) {
        dataMap = []
        let dataAll = []
        let i = 0
        if (start===0) 
          start = length
        else {
          start = (start*1)+length
          i = start - length
        }
        
        result.data.forEach((item,index)=>{
          if (item.quantity>0) {
            dataAll.push(item)
          }
        })
        totalPage = dataAll.length / length
        dataAll.forEach((item,index)=>{
          if (index>=i&&index<start) {
            dataMap.push(item)
          }
        })  
      }

      let data = dataMap.map((item,index)=>{
        let code = ""
        let des = ""
        if (query!=="") {
          code = item.productcode.replace(query, '<span className="text-highlight">'+query+'</span>');
          des = item.description.replace(query, '<span className="text-highlight">'+query+'</span>');
        } else {
          code = item.productcode
          des = item.description
        }
        textCode[index] = code
        textDes[index] = des

        if(item.car_cat_id!==undefined){
          let title = item.brand+"/"+item.model+"/"+item.series
          item.carInfo = {title:title,series:{value:item.car_cat_id}}
          item.stock_part_id = item.itemnum+'.'+item.car_cat_id
        }
        if(that.props.tool==='part' && that.props.searchType==='brand'){
          item.stock_part_id = item.itemnum+'.'+that.props.catId
          item.car_cat_id = that.props.catId
          
        }
        localdata.push({isShowInfo:false})
        return item
      })
      that.setState({ textCode:textCode, textDes:textDes, loading: false, data: data,localdata:localdata, totalPage: Math.ceil(totalPage) })
      that.refs.excelRef.getWrappedInstance().clearItem()
    },function(error){
      that.setState({loading:false})
    })
  }

  loadAdvancedStockList(page = 1, cat_id = '', query = '', filter = '') {
    let that = this
    let {textCode,textDes,showItemMore0,length,advanced_search} = that.state
    textCode.length = length
    textDes.length = length
    this.setState({ loading: true, textCode:textCode, textDes:textDes })
    var start = 0
    if (page === 1) {
      start = 0
      this.setState({ activePage: page })
    } else {
      start = (page * length) - length
    }
    
    ReportStore.loadAdvancedStockList(this.props.tool, query, cat_id, (showItemMore0?'':start), (showItemMore0?'':length), filter, advanced_search, function (result) {
      let localdata = []
      let totalPage = result.total_count / length
      let dataMap = result.data
      if (showItemMore0) {
        dataMap = []
        let dataAll = []
        let i = 0
        if (start===0) 
          start = length
        else {
          start = (start*1)+length
          i = start - length
        }
        
        result.data.forEach((item,index)=>{
          if (item.quantity>0) {
            dataAll.push(item)
          }
        })
        totalPage = dataAll.length / length
        dataAll.forEach((item,index)=>{
          if (index>=i&&index<start) {
            dataMap.push(item)
          }
        })  
      }

      let data = dataMap.map((item,index)=>{
        let code = ""
        let des = ""
        if (query!=="") {
          code = item.productcode.replace(query, '<span className="text-highlight">'+query+'</span>');
          des = item.description.replace(query, '<span className="text-highlight">'+query+'</span>');
        } else {
          code = item.productcode
          des = item.description
        }
        textCode[index] = code
        textDes[index] = des

        if(item.car_cat_id!==undefined){
          let title = item.brand+"/"+item.model+"/"+item.series
          item.carInfo = {title:title,series:{value:item.car_cat_id}}
          item.stock_part_id = item.itemnum+'.'+item.car_cat_id
        }
        if(that.props.tool==='part' && that.props.searchType==='brand'){
          item.stock_part_id = item.itemnum+'.'+that.props.catId
          item.car_cat_id = that.props.catId
          
        }
        localdata.push({isShowInfo:false})
        return item
      })
      that.setState({ textCode:textCode, textDes:textDes, loading: false, data: data,localdata:localdata, totalPage: Math.ceil(totalPage) })
      that.refs.excelRef.getWrappedInstance().clearItem()
    },function(error){
      that.setState({loading:false})
    })
  }

  onConfirmStockDelete() {
    let { dataInOut } = this.state
    let {messages} = this.props
    let that = this
    StockStore.deleteProducts(this.props.tool, dataInOut, function (result) {
      that.loadData()
      that._notificationSystem.addNotification({
        title: messages['Notification'],
        message: messages['Item Deleted Successfully'],
        level: 'info',
        position: 'tc'
      });
      that.setState({ dataInOut:[], btnDisplay:'none' })
    })
  }

  onInOutOpenClick(key, e) {
    let {messages} = this.props
    const yTh = parseInt(Moment().format('YYYY')) + 543
    const date = Moment().format('L LT').replace(Moment().format('YYYY'), yTh);

    if (key == "export") {
      var title = messages['Export Item']
      if (this.props.tool === "tool" || this.props.tool === "officemate") {
        var titleTextInOut = messages['RequesterOut']
      } else {
        var titleTextInOut = messages['RequesterOutCust']
      }
    } else if (key === "import") {
      var title = messages['Import Item']
      var titleTextInOut = messages['RequesterIn']
    } else if (key === "request_purchase") {
      var title = messages['Purchase Order Request']
      var titleTextInOut = messages['RequesterPO']
    }

    let { defaultQu,defaultCost } = this.state
    for (var i = 0; i < this.state.dataInOut.length; i++) {
      defaultQu[this.state.dataInOut[i].itemnum] = 1
      defaultCost[this.state.dataInOut[i].itemnum] = 0
    }

    this.setState({ defaultQu: defaultQu, record_type: key, showStockNewInOut: true, createDate: date, StockNewInOutTitle: title, titleTextInOut: titleTextInOut })
  }

  onExportExcelClick() {
    this.refs.excelRef.getWrappedInstance().onClick()
  }

  onInOutQuantityChange(e) {
    let { defaultQu } = this.state
    defaultQu[e.key] = e.value
    this.setState({ defaultQu: defaultQu })
  }

  onInOutCostChange(e) {
    let { defaultCost } = this.state
    defaultCost[e.key] = e.value
    this.setState({ defaultCost: defaultCost })
  }

  onInOutCancelClick() {
    this.state.checked.map((item, index) => {
      if (item == true) {
        this.state.checked[index] = false
        this.state.trStyle[index] = ""
      }
    })
    this.setState({ showStockNewInOut: false, btnDisplay: "none", dataInOut: [], rowCheck: [], trStyle: this.state.trStyle, checked: this.state.checked })
  }

  onInOutCloseClick() {
    this.setState({ showStockNewInOut: false })
  }

  getRowStyle(item, index) {
    if (item.quantity == 0) {
      return 'stock-red-row'
    } else if (item.quantity <= 3) {
      return 'stock-orange-row'
    } else if (item.quantity > 3) {
      return ''
    }
  }
  
  onPartSeriesClick(item,index,e){
    if (!this.state.checked[item.stock_part_id]) {

      if(this.props.onItemSelect!==undefined){
        item = this.props.onItemSelect(item)
      }
      this.state.rowCheck.push(item.stock_part_id)
      this.state.dataInOut.push(item)
      this.setState({ rowCheck: this.state.rowCheck, dataInOut: this.state.dataInOut })


      var newColor = "#eee"
      this.state.trStyle[item.stock_part_id] = newColor
      this.state.checked[item.stock_part_id] = true
      this.setState({ trStyle: this.state.trStyle, checked: this.state.checked })

      let nItem = {}
      nItem['itemnum'] = item.itemnum
      nItem['detail'] = item.description
      nItem['productcode'] = item.productcode
      nItem['quantity'] = item.quantity
      this.refs.excelRef.getWrappedInstance().addItem(nItem)

    } else {

      var key = this.state.rowCheck.indexOf(item.stock_part_id);
      this.state.rowCheck.splice(key, 1)
      this.state.dataInOut.splice(key, 1)

      this.setState({ rowCheck: this.state.rowCheck, dataInOut: this.state.dataInOut })

      this.state.checked[item.stock_part_id] = false
      var newColor = ""
      this.state.trStyle[item.stock_part_id] = newColor
      this.setState({ trStyle: this.state.trStyle })

      let rItem = {}
      rItem['itemnum'] = item.itemnum
      rItem['detail'] = item.description
      rItem['productcode'] = item.productcode
      rItem['quantity'] = item.quantity
      this.refs.excelRef.getWrappedInstance().removeItem(rItem)
    }

    if (this.state.rowCheck.length > 0) {
      this.setState({ btnDisplay: "" })
    } else {
      this.setState({ btnDisplay: "none" })
    }

    this.setState({ countPartSelect: this.state.rowCheck.length })
  }

  onPartClick(item, index, e) {    
    if (!this.state.checked[item.itemnum]) {

      if(this.props.onItemSelect!==undefined){
        item = this.props.onItemSelect(item)
      }
      this.state.rowCheck.push(item.itemnum)
      this.state.dataInOut.push(item)
      this.setState({ rowCheck: this.state.rowCheck, dataInOut: this.state.dataInOut })


      var newColor = "#eee"
      this.state.trStyle[item.itemnum] = newColor
      this.state.checked[item.itemnum] = true
      this.setState({ trStyle: this.state.trStyle, checked: this.state.checked })

      
      let nItem = {}
      nItem['itemnum'] = item.itemnum
      nItem['detail'] = item.description
      nItem['productcode'] = item.productcode
      nItem['quantity'] = item.quantity
      this.refs.excelRef.getWrappedInstance().addItem(nItem)

    } else {

      var key = this.state.rowCheck.indexOf(item.itemnum);
      this.state.rowCheck.splice(key, 1)
      this.state.dataInOut.splice(key, 1)

      this.setState({ rowCheck: this.state.rowCheck, dataInOut: this.state.dataInOut })

      this.state.checked[item.itemnum] = false
      var newColor = ""
      this.state.trStyle[item.itemnum] = newColor
      this.setState({ trStyle: this.state.trStyle })

      let rItem = {}
      rItem['itemnum'] = item.itemnum
      rItem['detail'] = item.description
      rItem['productcode'] = item.productcode
      rItem['quantity'] = item.quantity
      this.refs.excelRef.getWrappedInstance().removeItem(rItem)
    }

    if (this.state.rowCheck.length > 0) {
      this.setState({ btnDisplay: "" })
    } else {
      this.setState({ btnDisplay: "none" })
    }

    this.setState({ countPartSelect: this.state.rowCheck.length })
  }

  onRowsPerPageChange(e) {
    let {showAdvanced} = this.state
    this.setState({length:e,activePage:1},()=>{
      if (showAdvanced)
        this.onAdvancedSearchClick(1)
      else
        this.loadStockList(1, this.state.cat_id, this.state.query, this.state.filter)
    })
  }

  handleSelect(e) {
    let { query, filter, showAdvanced } = this.state
    let cat_id = this.state.defaultOption
    if(this.props.catId!==undefined){
      cat_id = this.props.catId
    }
    this.setState({ activePage: e },()=>{
      if (showAdvanced)
        this.onAdvancedSearchClick(e)
      else
        this.loadStockList(e, cat_id, query, filter)
    })
  }

  onCategoryChange(e) {
    this.setState({ defaultOption: e.value, showAdvanced:false })
    this.loadStockList(1, e.value, '', this.state.filter)
  }

  onTextChange(e) {
    this.setState({ query: e.target.value })
  }

  onSearchKeyPress(e) {
    let { query, filter } = this.state
    let cat_id = this.state.defaultOption
    if(this.props.catId!==undefined){
      cat_id = this.props.catId
    }

    if (e.charCode === 13) {
      this.loadStockList(1, cat_id, query, filter)
    }
  }

  onSearchClick() {
    let { query, filter } = this.state
    let cat_id = this.state.defaultOption
    if(this.props.catId!==undefined){
      cat_id = this.props.catId
    }
    this.setState({showAdvanced:false})
    this.loadStockList(1, cat_id, query, filter)
  }

  onAdvancedOptionsChange(e) {
    let {advanced_search,query,filter,defaultOption} = this.state
    let cat_id = defaultOption
    if(this.props.catId!==undefined){
      cat_id = this.props.catId
    }
    advanced_search = (e?e.value:'')
    this.setState({advanced_search:advanced_search},()=>{
      this.loadAdvancedStockList(1, cat_id, query, filter)
    })
  }

  onAdvancedTextChange(e) {
    let {advanced_q} = this.state
    advanced_q = e.target.value
    this.setState({advanced_q:advanced_q})
  }

  onAdvancedSearchKeyPress(e) {
    let { advanced_q, filter } = this.state
    let cat_id = this.state.defaultOption
    if(this.props.catId!==undefined){
      cat_id = this.props.catId
    }

    if (e.charCode === 13) {
      this.loadAdvancedStockList(1, cat_id, advanced_q, filter)
    }
  }

  onAdvancedSearchClick(page=1,e) {
    let { advanced_q, filter } = this.state
    let cat_id = this.state.defaultOption
    if(this.props.catId!==undefined){
      cat_id = this.props.catId
    }
    this.loadAdvancedStockList(page, cat_id, advanced_q, filter)
  }

  loadStockTransactionRecord(item) {
    let that = this
    this.setState({transaction_record:[]})
    StockStore.loadStockTransactionRecord(this.props.tool, item.itemnum, function (result) {
      let data = result.data
      data.push({ cost_per_unit: item.cost_per_unit, added_date: item.added_date, record_type: 'init', request_by: item.added_by, quantity: that.props.messages['Data Not Found'] })
      that.setState({ transaction_record: data })
    },function(){
      
    })
  }

  // onStockProductTransactionOpenClick(item, e) {

  //   if (item.itemnum > 0) {
  //     let that = this
  //     StockStore.loadImages(this.props.tool, item.itemnum, function (result) {
  //       that.setState({ productImages: result.data.files })
  //     })
  //   }

  //   let dataSet = {}
  //   dataSet = JSON.parse(JSON.stringify(item))
  //   dataSet = Object.assign({cat_id:dataSet.category},dataSet)
  //   dataSet['last_serial_id'] = ""
  //   dataSet['part_type'] = ""

  //   if(this.props.tool==='part' && this.props.searchType==='brand')
  //     dataSet['car_cat_id'] = this.props.catId

  //   this.setState({
  //     showStockProductTransactionPopup: true,
  //     description: item.description,
  //     added_date: item.added_date,
  //     added_by: item.added_by,
  //     quantity: item.quantity,
  //     unit: item.unit,
  //     remark: item.remark,
  //     productcode: item.productcode,
  //     last_serial_id: item.last_serial_id,
  //     itemnum: item.itemnum,
  //     cat_id: item.cat_id,
  //     dataSet: dataSet
  //   })
  // }

  onStockProductTransactionOpenClick(item, e) {
    if (this.props.tool!=='genpart') {
      if (item.itemnum > 0) {
        let that = this
        StockStore.loadImages(this.props.tool, item.itemnum, function (result) {
          that.setState({ productImages: result.data.files })
        })
      }
  
      let dataSet = {}
      dataSet = JSON.parse(JSON.stringify(item))
      dataSet = Object.assign({cat_id:dataSet.category},dataSet)
      dataSet['last_serial_id'] = ""
      dataSet['part_type'] = ""
  
      if(this.props.tool==='part' && this.props.searchType==='brand')
        dataSet['car_cat_id'] = this.props.catId
  
      this.setState({
        showStockProductTransactionPopup: true,
        description: item.description,
        added_date: item.added_date,
        added_by: item.added_by,
        quantity: item.quantity,
        unit: item.unit,
        remark: item.remark,
        productcode: item.productcode,
        last_serial_id: item.last_serial_id,
        itemnum: item.itemnum,
        cat_id: item.cat_id,
        dataSet: dataSet
      })
    } else {
      if (item.itemnum > 0) {
        let that = this
        StockStore.loadNewImages(this.props.tool, item.itemnum, function (result) {
          let dataSet = result.data.product
          let replacement = []
          replacement = result.data.replacement.map((item,index)=>{
            item = Object.assign({code_options:[]},item)
            return item
          })
          that.setState({
            showStockProductTransactionPopup: true,
            description:item.description,
            added_date:item.added_date,
            added_by:item.added_by,
            quantity:item.quantity,
            unit:item.unit,
            remark:item.remark,
            productcode:item.productcode,
            itemnum:item.itemnum,
            cat_id:item.cat_id,
            dataSet:dataSet,
            productImages:result.data.files, 
            location:result.data.location,
            location_config:result.data.location_config,
            replacement:replacement,
            spec:result.data.spec
          })
        })
      }
    }  
  }

  onStockProductTransactionCloseClick() {
    this.setState({ showStockProductTransactionPopup: false, itemnum: "", dataSet: {}, transaction_record: [] })
  }

  onStockNewProductOpenClick(){
    this.setState({
      showStockPopup:true,
      productImages:[],
      dataSet : {cat_id:'',description:'',cost_per_unit:'',price_per_unit:'',is_container:0,location:'',remark:'',productcode:'',barcode:'',shop_list:[]}
    })
  }

  onStockEditProductOpenClick() {
    let {itemnum} = this.state

    this.setState({
      showStockPopup: true,
      showStockProductTransactionPopup: false,
      transaction_record: [],
      productImages: [],      
    })
    if (itemnum > 0) {
      let that = this
      StockStore.loadImages(this.props.tool, itemnum, function (result) {
        that.setState({ productImages: result.data.files })
      })
    }
  }

  onStockEditProductCloseClick() {
    this.setState({showStockPopup:false,itemnum: "",dataSet:[],showStockProductTransactionPopup:false})
  }


  onStockEditProductCategoryChange(e) {
    let dataSet = this.state.dataSet
    dataSet['cat_id'] = e
    this.setState({ cat_id: e, dataSet: dataSet })
  }

  onTextStockEditProductChange(e) {
    let dataSet = this.state.dataSet
    dataSet[e.key] = e.value
    this.setState({dataSet:dataSet})

  }

  onStockEditPartTypeChange(partType){
    let {dataSet} = this.state
    this.setState({dataSet:dataSet})
  }

  onInOutDeleteClick(e) {
    let { rowCheck } = this.state
    let data = this.state.dataInOut
    var key = ""

    for (var i = 0; i < this.state.dataInOut.length; i++) {
      if (e == this.state.dataInOut[i].itemnum) {
        key = i
      }
    }

    data.splice(key, 1)
    this.state.checked[e] = false
    this.state.trStyle[e] = ""

    var keyRowCheck = rowCheck.indexOf(e)
    rowCheck.splice(keyRowCheck, 1)

    this.setState({ dataInOut: data, trStyle: this.state.trStyle, checked: this.state.checked, rowCheck: rowCheck, countPartSelect: rowCheck.length })
    if (rowCheck.length < 1) {
      this.setState({ btnDisplay: "none" })
    }
  }

  onImageUpload(complete) {
    //console.log('onImageUpload')
    let { itemnum } = this.state
    if (itemnum > 0) {
      let that = this
      StockStore.loadImages(this.props.tool, itemnum, function (result) {
        that.setState({ productImages: result.data.files })
        if (complete!=undefined) {
          let callBack = {status:'OK',data:result.data.files}
          complete(callBack)
        }
      })
    }
  }

  onNewCategory() {
    this.loadCategory()
  }

  onPartTypeChange(index,value){
    let {dataInOut} = this.state
    dataInOut[index].partType = value.value
    this.setState({dataInOut:dataInOut})
  }

  onPartSeriesDetailClick(item,index){
    let that = this
    let {data,localdata} = this.state

    
    if(data.original_info===undefined){
      StockStore.loadPartTypeInfo(item.itemnum,item.car_cat_id,function(result) {      
        data[index] = Object.assign(item,result.data[0])        
        that.setState({data:data})
      })      
    }
    localdata[index].isShowInfo = !localdata[index].isShowInfo
    this.setState({localdata:localdata})
  }

  onShowItemMore0() {
    let {showItemMore0,showItem0,defaultOption,query,filter} = this.state
    if (showItemMore0) {
      showItemMore0 = false
    } else {
      showItemMore0 = true
      showItem0 = false
      filter = ''
    }
    
    this.setState({showItemMore0:showItemMore0,activePage:1,filter:filter,showItem0:showItem0,showAdvanced:false}) 
    setTimeout(()=>{
      this.loadStockList(1,defaultOption,query,filter)
    },100) 
  }

  onShowItem0() {
    let {showItemMore0,showItem0,defaultOption,query,filter,length} = this.state
    if (showItem0) {
      showItem0 = false
      filter = ''
    } else {
      showItem0 = true
      showItemMore0 = false
      filter = 'only_outofstock'
    }
    this.setState({showItem0:showItem0,activePage:1,filter:filter,showItemMore0:showItemMore0,showAdvanced:false}) 
    setTimeout(()=>{
      this.loadStockList(1,defaultOption,query,filter)
    },100) 
  }

  renderTable() {
    let {messages} = this.props
    if (this.props.tool === "tool" || this.props.tool === "officemate" ||this.props.tool === "color" ) {
      return (
        <div className='display-overflow'>
          <table className="table table-responsive table-hover table-bordered-solid">
            <thead>
              <tr>
                <th></th>
                <th>{messages['Product Code']}</th>
                <th className="col-md-4">{messages['Part Name']}</th>
                <th className="text-center">{messages['Quantity']}</th>
                <th className="text-center">{messages['Unit']}</th>
                <th className="text-center">{messages['Type']}</th>
                <th className="text-center">{messages['Cost']}</th>
                <th className="text-center">{messages['Shelf']}</th>
                <th>{messages['Remark']}</th>
              </tr>
            </thead>
            <tbody>
              {this.renderRowData()}
            </tbody>
          </table>
        </div>
      )
     }else if (this.props.tool === "part") {
        if (this.props.searchType === 'brand') {
          return (
            <div className='display-overflow'>
              <table className="table table-responsive table-hover table-bordered-solid">
                <thead>
                  <tr>
                    <th rowSpan={2}></th>                    
                    <th rowSpan={2} className="col-md-4">{messages['Part Name']}</th>
                    <th rowSpan={2} className="text-center" style={{width:'100px'}}>{messages['Model']}</th>
                    <th rowSpan={2}>{messages['Info']}</th>                    
                    <th colSpan={3} className="text-center">{messages['Quantity']}</th>
                    <th rowSpan={2} className="text-center">{messages['Unit']}</th>
                    <th rowSpan={2} className="text-center">{messages['Type']}</th>
                  </tr>
                  <tr>
                    <th className="text-center">({messages['Original']})</th>
                    <th className="text-center">({messages['Similar']})</th>
                    <th className="text-center">({messages['Old']})</th>                  
                  </tr>
                </thead>
                <tbody>
                  {this.renderRowData()}
                </tbody>
              </table>
            </div>
          )
        } else if (this.props.searchType === 'freetext') {
          return (
            <div className='display-overflow'>
              <table className="table table-responsive table-hover table-bordered-solid">
                <thead>
                  <tr>
                    <th rowSpan={2}></th>                    
                    <th rowSpan={2} className="col-md-4">{messages['Part Name']}</th>
                    <th rowSpan={2} className="text-center" style={{width:'100px'}}>รุ่นรถ</th>
                    <th rowSpan={2}>ข้อมูล</th>                    
                    <th colSpan={3} className="text-center">{messages['Quantity']}</th>
                    <th rowSpan={2} className="text-center">{messages['Unit']}</th>
                    <th rowSpan={2} className="text-center">{messages['Type']}</th>
                  </tr>
                  <tr>
                    <th className="text-center">({messages['Original']})</th>
                    <th className="text-center">({messages['Similar']})</th>
                    <th className="text-center">({messages['Old']})</th>                  
                  </tr>
                </thead>
                <tbody>
                  {this.renderRowData()}
                </tbody>
              </table>
            </div>
          )
        }
    } else {
      return (
        <div className='display-overflow'>
          <table className="table table-responsive table-hover table-bordered-solid">
            <thead>
              <tr>
                <th></th>
                <th>{messages['Product Code']}</th>
                <th className="col-md-6">{messages['Part Name']}</th>
                <th className="text-center">{messages['Quantity']}</th>
                <th className="text-center">{messages['Unit']}</th>
                <th className="text-center">{messages['Type']}</th>
                <th className="text-center">{messages['Cost']}</th>
                <th className="text-center">{messages['Price']}</th>
                <th className="text-center">{messages['Shelf']}</th>
                <th>{messages['Remark']}</th>
              </tr>
            </thead>
            <tbody>
              {this.renderRowData()}
            </tbody>
          </table>
        </div>
      )
    }
  }

  renderDescription(item,index){
    let {textDes} = this.state
    if(item.container_unit!==undefined&&item.container_unit!==''){
      return item.description + ' ('+item.container_quantity+' '+item.container_unit+')'
    }else{
      return Parser('<div>'+textDes[index]+'</div>')
    }
  }

  getDecimal(number) {
    if (isNaN(number)) {
      return 0
    } else if (number==="") { 
      return ""
    } else {
      return parseFloat(number).toFixed(2) * 1
    }
  }

  renderNumber(value,type){
    if(type!==undefined && type==='number'){
      return (<td className='text-right'>{(value*1).toLocaleString(undefined, {minimumFractionDigits: 0})}</td>)
    }else{
      return (<td>{value}</td>)
    }
  }

  renderPartInfo(item,index){
    let {localdata} = this.state
    let {messages} = this.props
    if(item.original_info!==undefined && localdata[index].isShowInfo){
      let rows = [{title:messages['Cost/Unit'],key:'cost_per_unit',type:'number'},{title:messages['Price/Unit'],key:'price_per_unit',type:'number'},
      {title:messages['Product Code'],key:'productcode'},{title:messages['Barcode'],key:'barcode'},
      {title:messages['Shelf'],key:'location'},{title:messages['Remark'],key:'remark'},]
      return rows.map((citem,cindex)=>(
        <tr key={(10000*index)+cindex}>              
              <td className='text-right' colSpan={4}>{citem.title}</td>
              {this.renderNumber(item.original_info[citem.key],citem.type)}
              {this.renderNumber(item.similar_info[citem.key],citem.type)}
              {this.renderNumber(item.old_info[citem.key],citem.type)}
          </tr>
      ))    
    }else if (localdata[index].isShowInfo) {
      let rows = [{title:messages['Cost/Unit'],key:'cost_per_unit'},{title:messages['Price/Unit'],key:'price_per_unit'},
      {title:messages['Product Code'],key:'productcode'},{title:messages['Barcode'],key:'barcode'},
      {title:messages['Shelf'],key:'location'},{title:messages['Remark'],key:'remark'},]
      return rows.map((citem,cindex)=>(
        <tr key={(10000*index)+cindex}>              
              <td className='text-right' colSpan={4}>{citem.title}</td>
              <td></td>
              <td></td>
              <td></td>
          </tr>
      ))
    } else {
      return('')
    }
  }

  renderRowData() {
    let {textCode,textDes,localdata} = this.state
    let {messages} = this.props
    if (this.state.loading) {
      return (<tr><td colSpan={10}><FontAwesome name="spinner"/>{messages['Fetching Data']}</td></tr>)
    }
    if (this.state.data.length === 0) {
      return (<tr><td colSpan={10}><FontAwesome name="frown-o"/>{messages['Data Not Found']}</td></tr>)
    } else {
      if (this.props.tool === "tool" || this.props.tool === "officemate" ||this.props.tool === "color" ) {
        return (
          this.state.data.map((item, index) =>
            <tr key={index} className={this.getRowStyle(item, index)} style={{ backgroundColor: this.state.trStyle[item.itemnum] }}>
              <td className="text-center">
                <Checkbox
                  onChange={this.onPartClick.bind(this, item, index)}
                  checked={this.state.checked[item.itemnum]}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                >
                </Checkbox>
              </td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)}>
                {Parser('<div>'+textCode[index]+'</div>')}
              </td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)}>
                {this.renderDescription(item,index)}
                {item.thumbnail_url!==''?<img src={item.thumbnail_url} style={{marginTop:'10px'}} />:''}
              </td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{this.getDecimal(item.quantity)}</td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.unit}</td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.cat_name}</td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{(item.cost_per_unit*1).toLocaleString(undefined, {minimumFractionDigits: 0})}</td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.location}</td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)}>{item.remark}</td>
            </tr>
          )
        )
      } else if (this.props.tool === "part") {
        if (this.props.searchType === 'brand') {
          return (
            this.state.data.map((item, index) =>
              [<tr key={index} className={this.getRowStyle(item, index)} style={{ backgroundColor: this.state.trStyle[item.itemnum] }}>
                <td className="text-center">
                  <Checkbox
                    onChange={this.onPartSeriesClick.bind(this, item, index)}
                    checked={this.state.checked[item.stock_part_id]}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=""
                  >
                  </Checkbox>
                </td>                
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)}>
                  {Parser('<div>'+textDes[index]+'</div>')}
                  {item.thumbnail_url!==''?<img src={item.thumbnail_url} style={{marginTop:'10px'}} />:''}
                </td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)}>
                  {this.props.carDetail}
                </td>
                <td className='text-center'><Button bsSize='sm' onClick={this.onPartSeriesDetailClick.bind(this,item,index)}><FontAwesome name='info'/>{' '}{localdata[index].isShowInfo?messages['Hide Data']:messages['View Data']}</Button></td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{this.getDecimal(item.original_quantity)}</td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{this.getDecimal(item.similar_quantity)}</td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{this.getDecimal(item.old_quantity)}</td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.unit}</td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.cat_name}</td>
              </tr>,
              this.renderPartInfo(item,index)              
              ]
            )
          )  
        } else if (this.props.searchType === 'freetext') {
          return (
            this.state.data.map((item, index) =>
              [<tr key={index} className={this.getRowStyle(item, index)} style={{ backgroundColor: this.state.trStyle[item.itemnum] }}>
                <td className="text-center">
                  <Checkbox
                    onChange={this.onPartSeriesClick.bind(this, item, index)}
                    checked={this.state.checked[item.stock_part_id]}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=""
                  >
                  </Checkbox>
                </td>                
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)}>
                  {Parser('<div>'+textDes[index]+'</div>')}
                  {item.thumbnail_url!==''?<img src={item.thumbnail_url} style={{marginTop:'10px'}} />:''}
                </td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)}>
                  {item.car_detail}
                </td>
                <td className='text-center'><Button bsSize='sm' onClick={this.onPartSeriesDetailClick.bind(this,item,index)}><FontAwesome name='info'/>{' '}{localdata[index].isShowInfo?messages['Hide Data']:messages['View Data']}</Button></td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{this.getDecimal(item.original_quantity)}</td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{this.getDecimal(item.similar_quantity)}</td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{this.getDecimal(item.old_quantity)}</td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.unit}</td>
                <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.cat_name}</td>
              </tr>,
              this.renderPartInfo(item,index)              
              ]
            )
          )
        }        
      } else {
        return (
          this.state.data.map((item, index) =>
            <tr key={index} className={this.getRowStyle(item, index)} style={{ backgroundColor: this.state.trStyle[item.itemnum] }}>
              <td className="text-center">
                <Checkbox
                  onChange={this.onPartClick.bind(this, item, index)}
                  checked={this.state.checked[item.itemnum]}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                >
                </Checkbox>
              </td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)}>
                {Parser('<div>'+textCode[index]+'</div>')}
              </td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)}>
                {this.renderDescription(item,index)}
                {item.thumbnail_url!==''?<img src={item.thumbnail_url} style={{marginTop:'10px'}} />:''}
              </td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{this.getDecimal(item.quantity)}</td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.unit}</td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.cat_name}</td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-right">{(item.cost_per_unit*1).toLocaleString(undefined, {minimumFractionDigits: 0})}</td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-right">{(item.price_per_unit*1).toLocaleString(undefined, {minimumFractionDigits: 0})}</td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)} className="text-center">{item.location}</td>
              <td onClick={this.onStockProductTransactionOpenClick.bind(this, item)}>{item.remark}</td>
            </tr>
          )
        )
      }
    }
  }

  onClearAfterSave() {
    this.setState({itemnum: "",dataSet:[]})
  }

  onReloadAfterSave(description) { console.log('onReloadAfterSave=>',description)
    let cat_id = this.state.defaultOption
    this.setState({query:description},()=>{
      if(this.props.catId!==undefined){
        cat_id = this.props.catId
      }
      this.loadStockList(1, cat_id, description, this.state.filter)
    })
  }

  onUpdateData(e,completeFunc=undefined) {
    let {data,textCode,textDes} = this.state
    if (e.key==='edit') {
      data.forEach(function(item,index) {
        if (item.itemnum===e.value.itemnum) {
          textCode[index] = e.value.productcode
          textDes[index] = e.value.description
          data[index] = Object.assign(e.value,{cat_name:e.value.new_cat})
        }
      })
    } else if (e.key==='add') {
      textCode.unshift(e.value.productcode)
      textDes.unshift(e.value.description)
      data.unshift({
        added_date:e.value.added_date,
        barcode:e.value.barcode,
        cat_id:e.value.cat_id,
        cat_name:e.value.new_cat,
        category:e.value.cat_id,
        cost_per_unit:e.value.cost_per_unit,
        price_per_unit:e.value.price_per_unit,
        itemnum:e.value.itemnum,
        location:e.value.location,
        remark:e.value.remark,
        unit:e.value.unit,
        quantity:e.value.quantity,
        productcode:e.value.productcode,
        description:e.value.description,
        shop_list:e.value.shop_list
      })
    }  
    this.setState({data:data,textCode:textCode,textDes:textDes},()=>{
      if (completeFunc!==undefined)
        completeFunc()
    })
  }

  onStockProductSerialManageClick(status) {
    this.setState({showProductSerial:status})
  }

  onNoticeSerial(status) {
    if(status){
      this._notificationSystem.addNotification({
        title: this.props.messages['Notification'],
        message: this.props.messages['Product Code Not Found'],
        level: 'error',
        position: 'tc'
      });
    }
  }

  onProductDeleteClick() {
    let {dataInOut,docMulti} = this.state
    let {messages} = this.props
    let itemnum = []
    let description = []
    dataInOut.forEach(function(item,index) {
      itemnum.push(item.itemnum)
      description.push(item.description)
    })
    let itemnums = itemnum.join(", ")
    let descriptions = description.join(", ")
    if (dataInOut.length>1) {
        docMulti = true
    }
    this.setState({showRemark:true,remarkTitle:messages['Remove Item']+descriptions,remarkItemnum:itemnums,docMulti:docMulti})
  }

  onRemarkClose(e) {
    this.setState({showRemark:false,remarkTitle:'',remarkItemnum:''})
  }

  onRemarkSuccess(e) {
    this.setState({showRemark:false,remarkTitle:'',remarkItemnum:''})
    this.onConfirmStockDelete()
  }

  onRowWorkClick(item,items) {
    this.onStockProductTransactionOpenClick(items)
  }

  onCheckCancel() {
    this.onInOutCancelClick()
  }

  renderMobileTable() {
    let {data} = this.state
    let fieldMap = {title:'description',amount:'_amount',sub_title:'productcode',date:'name',status:'',sub_status:''}
    let _data = []
    _data = data.map((item,index)=>{
      let _item = item
      _item = Object.assign({_amount:item.quantity+' '+item.unit}, _item)
      return _item
    })
    if (this.props.tool=='part'&&this.props.searchType=='freetext') {
      fieldMap = {title:'description',amount:'cat_name',sub_title:'car_detail',date:'series',status:'',sub_status:''}
    }
    return(
      <div>
        <ReportMobileTable
          itemlist={_data}
          fieldMap={fieldMap}
          keyIndex={'itemnum'}
          numberFormat={false}
          onRowClick={this.onRowWorkClick.bind(this)}
        />
      </div>
    )
  }

  onLocationChange(status) {
    let {dataSet} = this.state
    dataSet.is_multiple_location = status
    this.setState({dataSet:dataSet})
  }

  onReplacementChange(status) {
    let {dataSet} = this.state
    dataSet.has_replacement = status
    this.setState({dataSet:dataSet})
  }

  onRowLocationChange(item) {
    let {location} = this.state
    if (item.field==='location_config_id') {
      location[item.index][item.field] = item.value.value
      location[item.index]['location_name'] = item.value.label
    } else
      location[item.index][item.field] = item.value
    this.setState({location:location})
  }

  onRowReplacementChange(item) {
    let {replacement} = this.state
    replacement[item.index][item.field] = item.value
    this.setState({replacement:replacement})
  }

  onReplacementRowAdd(item,complete) {
    let {replacement} = this.state
    replacement.push(item)
    this.setState({replacement:replacement},()=>{
      if (complete!==undefined)
        complete('OK')
    })
  }

  onLocationRowAdd(item,complete) {
    let {location} = this.state
    location.push(item)
    this.setState({location:location},()=>{
      if (complete!==undefined)
        complete('OK')
    })
  }

  onLocationConfigRowAdd(item,complete) {
    let {location_config} = this.state
    location_config.push(item)
    this.setState({location_config:location_config},()=>{
      if (complete!==undefined)
        complete('OK')
    })
  }

  onRowLocationConfigChange(item) {
    let {location_config} = this.state
    location_config[item.index][item.field] = item.value
    this.setState({location_config:location_config})
  }

  onLocationConfigSave(item,complete) {
    let {location_config} = this.state
    StockStore.saveProductLocationConfig(location_config,(result)=>{
      if (result.status==='OK') {
        this.setState({location_config:result.data})
        if (complete!==undefined)
          complete('OK')
      }
    })
  }

  onRowReplacementDel(index) {
    let {replacement} = this.state
    if (replacement[index].bf_replacement_item_id!=='')
      replacement[index] = Object.assign({mark_to_delete:true},replacement[index])
    else
      replacement.splice(index,1)

    this.setState({replacement:replacement})
  }

  onRowLocationDel(index) {
    let {location} = this.state
    if (location[index].bf_location_item_id!=='')
      location[index] = Object.assign({mark_to_delete:true},location[index])
    else
      location.splice(index,1)

    this.setState({location:location})
  }

  onRowLocationConfigDel(index) {
    let {location_config} = this.state
    if (location_config[index].location_config_id!=='')
      location_config[index] = Object.assign({mark_to_delete:true},location_config[index])
    else
      location_config.splice(index,1)

    this.setState({location_config:location_config})
  }

  renderStockEditProductModal(mode) {
    return(
          <StockEditProductModal
            {...this.props.config}
            mode={mode}
            ref='editProduct'            
            show={this.state.showStockPopup}
            onHide={this.onStockEditProductCloseClick.bind(this)}
            tool={this.props.tool}
            searchType={this.props.searchType}
            images={this.state.productImages}
            onCatChange={this.onStockEditProductCategoryChange.bind(this)}
            onTextChange={this.onTextStockEditProductChange.bind(this)}
            onImageUpload={this.onImageUpload.bind(this)}
            onNewCategory={this.onNewCategory.bind(this)}
            dataSet={this.state.dataSet}
            updateData={this.onUpdateData.bind(this)}
            clearAfterSave={this.onClearAfterSave.bind(this)}
            onReloadAfterSave={this.onReloadAfterSave.bind(this)}
            onLocationChange={this.onLocationChange.bind(this)}
            onReplacementChange={this.onReplacementChange.bind(this)}
            onRowLocationChange={this.onRowLocationChange.bind(this)}
            onRowLocationConfigChange={this.onRowLocationConfigChange.bind(this)}
            onRowReplacementChange={this.onRowReplacementChange.bind(this)}
            onReplacementRowAdd={this.onReplacementRowAdd.bind(this)}
            onRowReplacementDel={this.onRowReplacementDel.bind(this)}
            onLocationRowAdd={this.onLocationRowAdd.bind(this)}
            onRowLocationDel={this.onRowLocationDel.bind(this)}
            onLocationConfigRowAdd={this.onLocationConfigRowAdd.bind(this)}
            onRowLocationConfigDel={this.onRowLocationConfigDel.bind(this)}
            onLocationConfigSave={this.onLocationConfigSave.bind(this)}
            location={this.state.location}
            location_config={this.state.location_config}
            replacement={this.state.replacement}
            spec={this.state.spec}
            stockType={this.props.tool}
          >
          </StockEditProductModal>
    )
  }

  render() {
    let {loading,showConfirmDelete,showAdvanced,length} = this.state
    let {showCat,isMobile,messages} = this.props
    const title = <div><FontAwesome name='file-text-o' className="color-orange" /> {messages['Create Order']}</div>
    const title2 = <div><FontAwesome name='arrow-down' className="color-blue" /> {messages['Create Export Item']}</div>
    const title3 = <div><FontAwesome name='arrow-up' className="color-green" /> {messages['Create Import Item']}</div>
    const title4 = <div><FontAwesome name='trash' className="color-red" /> {messages['Remove Item']}</div>
    const title5 = <div><FontAwesome name='shopping-cart' className="color-orange" /> {messages['Create Purchase Order Approval']}</div>
    const title6 = <div><FontAwesome name='file-excel-o' className="color-green" /> {messages['Excel File List']}</div>
    const title7 = <div><FontAwesome name='ban' className="color-red" /> {messages['Unselect']}</div>
    const options = [{value:'all',label:'----- '+messages['All']+' -----'}]
    {
      this.state.dataDd.map((item, index) =>
        options.push({
          value: item.cat_id,
          label: item.name
        })
      )
    }

    let boxTitle = messages['Search For']+this.props.title

    return (
      <div>
        <Box loading={loading}>
          <Box.Header>
            <Box.Title>{boxTitle}</Box.Title>
            <Box.Tools>
              <Button
                style={{display:(this.props.searchType=='freetext'?'none':'')}}
                bsStyle={'link'} className='text-large'
                onClick={this.onStockNewProductOpenClick.bind(this)}
              >
                <FontAwesome name='plus' /> {messages['Add Item']}
              </Button>
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            <Form inline style={{marginBottom:'5px'}}>
              <FormGroup style={{display:(showCat)?'inline-block':'none'}}>
                <Select
                  clearable={false}
                  name="form-field-name"
                  value={this.state.defaultOption}
                  options={options}
                  style={{ width: "200px" }}
                  onChange={this.onCategoryChange.bind(this)}
                />
              </FormGroup>
              {' '}
              <FormGroup>
                <InputGroup>
                  <InputGroup>
                    <FormControl type="text" placeholder={messages['Item Name']+'...'} onChange={this.onTextChange.bind(this)} onKeyPress={this.onSearchKeyPress.bind(this)} />
                    <InputGroup.Addon className="btn" onClick={this.onSearchClick.bind(this)}>
                      <FontAwesome name='search' />
                    </InputGroup.Addon>
                  </InputGroup>
                </InputGroup>
              </FormGroup>
              {' '}
              <FormGroup>
                <Checkbox
                  onChange={this.onShowItemMore0.bind(this)}
                  checked={this.state.showItemMore0}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label={' '+messages['Only Show Numbers']}
                />
              </FormGroup>
              {' '}
              <FormGroup>
                <Checkbox
                  onChange={this.onShowItem0.bind(this)}
                  checked={this.state.showItem0}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=" แสดงเฉพาะที่ขาดสต็อก"
                />
              </FormGroup>
              {' '}
              <FormGroup style={{display: this.state.btnDisplay}}>
                <FormControl readOnly={true} value={messages['Select']+' '+this.state.countPartSelect+' '+messages['List']} />
              </FormGroup>  
              {' '}
              <DropdownButton bsStyle={'primary'} title={messages['Manage Item']} key="" id="" style={{ display: this.state.btnDisplay }}>
                <MenuItem eventKey="1" style={{ display: 'none' }}>{title}</MenuItem>
                <MenuItem eventKey="2" onClick={this.onInOutOpenClick.bind(this, 'export')}>{title2}</MenuItem>
                <MenuItem eventKey="3" style={{display:(this.props.searchType=='freetext'?'none':'')}} onClick={this.onInOutOpenClick.bind(this, 'import')}>{title3}</MenuItem>
                <MenuItem divider style={{margin:(this.props.searchType=='freetext'?'5px 0':'9px 0'),display:(this.props.searchType=='freetext'?'none':'')}} />
                <MenuItem eventKey="5" style={{display:(this.props.searchType=='freetext'?'none':'')}} onClick={this.onInOutOpenClick.bind(this, 'request_purchase')}>{title5}</MenuItem>
                <MenuItem divider style={{margin:(this.props.searchType=='freetext'?'5px 0':'9px 0')}} />
                <MenuItem eventKey="6" style={{display:(this.props.searchType=='freetext'?'none':'')}} onClick={this.onExportExcelClick.bind(this)}>{title6}</MenuItem>
                <MenuItem divider style={{margin:(this.props.searchType=='freetext'?'5px 0':'9px 0')}} />
                <MenuItem eventKey="7" onClick={this.onCheckCancel.bind(this)}>{title7}</MenuItem>
                {this.props.config.showDeleteMenu && this.props.config.showDeleteMenu === true  && (
                <MenuItem eventKey="4" onClick={this.onProductDeleteClick.bind(this)}>{title4}</MenuItem>)}
              </DropdownButton>
            </Form>
            {this.props.tool!="tool" && (
            <Form inline>
              <FormGroup>
                <Button onClick={()=>{this.setState({showAdvanced:!showAdvanced})}} bsSize='lg' bsStyle='link'><FontAwesome name={showAdvanced?'minus':'plus'} /> {messages['Advanced search']}</Button>
              </FormGroup>            
              {' '}
              {showAdvanced
              ?
              <FormGroup>
                <Select
                  className='height-menu-outer'
                  placeholder={messages['Select2']}
                  clearable={true}
                  value={this.state.advanced_search}
                  options={this.state.advanced_options}
                  style={{width:"200px"}}
                  onChange={this.onAdvancedOptionsChange.bind(this)}
                />
              </FormGroup>
              :''}
              {' '}
              {showAdvanced
              ?
              <FormGroup>
                <InputGroup>
                  <FormControl value={this.state.advanced_q} placeholder={messages['Advanced search']+'...'} onChange={this.onAdvancedTextChange.bind(this)} onKeyPress={this.onAdvancedSearchKeyPress.bind(this)} />
                  <InputGroup.Addon className="btn" onClick={this.onAdvancedSearchClick.bind(this,1)}>
                    <FontAwesome name='search' />
                  </InputGroup.Addon>
                </InputGroup>
              </FormGroup>
              :''}
            </Form>)}
            {isMobile?this.renderMobileTable():this.renderTable()}
          </Box.Body>
        </Box>
        <div>
          <div className="text-right">
            <Form inline>
              <FormGroup style={{marginBottom:'8px'}}>
                {messages['Number Of Rows Per Page']}
              </FormGroup>  
              {' '}
              <FormGroup style={{marginBottom:'8px'}}>
                <DropdownButton id='stock-row-per-page' bsStyle={'default'} title={length===0?messages['All']:length} onSelect={this.onRowsPerPageChange.bind(this)}>
                  {this.state.optionsRows.map((item,index)=>(
                    <MenuItem key={index} eventKey={item}>{item===0?messages['All']:item}</MenuItem>  
                  ))}
                </DropdownButton>
              </FormGroup>
              {' '}
              <FormGroup>
                <Pagination
                  prev={messages['Previous']}
                  next={messages['Next']}
                  first={false}
                  last={false}
                  ellipsis
                  boundaryLinks
                  items={this.state.totalPage}
                  maxButtons={5}
                  activePage={this.state.activePage}
                  onSelect={this.handleSelect.bind(this)}
                />
              </FormGroup>
            </Form>  
          </div>
        </div>
        {/* <div>
          <StockEditProductModal
            ref='editProduct'
            show={this.state.showStockPopup}
            onHide={this.onStockEditProductCloseClick.bind(this)}
            tool={this.props.tool}
            searchType={this.props.searchType}
            images={this.state.productImages}
            onCatChange={this.onStockEditProductCategoryChange.bind(this)}
            onTextChange={this.onTextStockEditProductChange.bind(this)}
            onImageUpload={this.onImageUpload.bind(this)}
            onNewCategory={this.onNewCategory.bind(this)}
            dataSet={this.state.dataSet}
            updateData={this.onUpdateData.bind(this)}
            clearAfterSave={this.onClearAfterSave.bind(this)}
          >
          </StockEditProductModal>
        </div> */}
        <div>
          {this.renderStockEditProductModal('modal')}
        </div>
        <div>
          <StockNewInOutModal
            onShow={this.state.showStockNewInOut}
            onHide={this.onInOutCloseClick.bind(this)}
            onCancel={this.onInOutCancelClick.bind(this)}
            openInoutPrintAfterSubmit={this.props.openInoutPrintAfterSubmit}
            data={this.state.dataInOut}
            onDelete={this.onInOutDeleteClick.bind(this)}
            date={this.state.createDate}
            title={this.state.StockNewInOutTitle}
            titleTextInOut={this.state.titleTextInOut}
            stockType={this.props.tool}
            recordType={this.state.record_type}
            allData={this.state.data}
            quChange={this.onInOutQuantityChange.bind(this)}
            costChange={this.onInOutCostChange.bind(this)}
            defaultQu={this.state.defaultQu}
            defaultCost={this.state.defaultCost}
            onPartTypeChange={this.onPartTypeChange.bind(this)}
          >
          </StockNewInOutModal>
        </div>
        <div>
          <StockProductTransactionModal
            show={this.state.showStockProductTransactionPopup}
            onHide={this.onStockProductTransactionCloseClick.bind(this)}
            onEdit={this.onStockEditProductOpenClick.bind(this)}
            description={this.state.description}
            added_date={this.state.added_date}
            added_by={this.state.added_by}
            role={this.props.role}            
            quantity={this.state.quantity}
            unit={this.state.unit}
            itemnum={this.state.itemnum}            
            stockType={this.props.tool}
            transaction_record={this.state.transaction_record}
            onShowSerialNumber={this.onStockProductSerialManageClick.bind(this)}
            itemData={this.state.dataSet}
            renderInfoTable={this.renderStockEditProductModal.bind(this)}     
          >
          </StockProductTransactionModal>
        </div>
        <div>
          <StockProductSerialManageModal
            stockType={this.props.tool}
            onShow={this.state.showProductSerial}
            onHide={()=>this.setState({showProductSerial:false})}
            onEdit={this.onStockEditProductOpenClick.bind(this)}
            quantity={this.state.quantity}
            description={this.state.description}
            unit={this.state.unit}
            productcode={this.state.productcode}
            itemnum={this.state.itemnum}
            last_serial_id={this.state.last_serial_id}            
            onNotice={this.onNoticeSerial.bind(this)}
          >
          </StockProductSerialManageModal>
        </div>
        <NotificationSystem ref="notificationSystem" />
        <ConfirmPopup show={showConfirmDelete}
          title={messages['Confirm']}
          message={messages['Confirm Deletion Of Item']}
          confirmTitle={messages['Confirm']}
          onConfirm={this.onConfirmStockDelete.bind(this)}
          onHide={() => { this.setState({ showConfirmDelete: false }) }}
        />
        <RemarkRecordModal
          show={this.state.showRemark}
          onHide={()=>this.setState({showRemark:false})}
          onSuccess={this.onRemarkSuccess.bind(this)}
          onModalClose={this.onRemarkClose.bind(this)}
          docName={'taxinvoice'}
          docNo={this.state.remarkItemnum}
          docTitle={this.state.remarkTitle}
          docTag={'delete'}
          docMulti={this.state.docMulti}
        />
        <ExportExcelButton 
          ref='excelRef' 
          showBtn={false}
        />
      </div>
    )
  }
}



StockSearchPage.defaultProps = {  
  show:false,
  showCat:true,  
  searchType:'',
  role:'',
  openInoutPrintAfterSubmit:true,
  config:{showOrder:true,showPickup:true,showLocation:true,showReplacement:true,showProductOption:false,showDeleteMenu:false}
}

export default connect(
  (state) => ({messages: state.message.view.stock.StockSearchPage}),null,null,{withRef:true},
)(StockSearchPage);





// WEBPACK FOOTER //
// ./src/view/stock/StockSearchPage.js